module.exports = __webpack_public_path__ + "static/media/girl_pic.8608bf77.svg";